import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse, User } from '@/types/site';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

// 사이트 매니저 목록 조회
export const useSiteManagersQuery = (siteId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.sites.getManagers, siteId],
    queryFn: async (): Promise<User[]> => {
      const response = await XHRAuthorizedClient.get<ApiResponse<User[]>>(
        ENDPOINTS.sites.managers(siteId)
      );
      return response.data.data;
    },
    enabled: !!siteId,
  });
};

// 사이트에 매니저 추가
export const useAddSiteManager = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.addManager],
    mutationFn: async ({
      siteId,
      managerId,
    }: {
      siteId: string;
      managerId: string;
    }): Promise<void> => {
      await XHRAuthorizedClient.post<ApiResponse<void>>(
        ENDPOINTS.sites.addManager(siteId, managerId)
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('사이트 매니저 추가 오류:', error);
    },
  });
};

// 사이트에서 매니저 제거
export const useRemoveSiteManager = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.removeManager],
    mutationFn: async ({
      siteId,
      managerId,
    }: {
      siteId: string;
      managerId: string;
    }): Promise<void> => {
      await XHRAuthorizedClient.delete<ApiResponse<void>>(
        ENDPOINTS.sites.removeManager(siteId, managerId)
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('사이트 매니저 제거 오류:', error);
    },
  });
};
